import { render, staticRenderFns } from "./templateContentSamplesModal.vue?vue&type=template&id=2cd27b6a&"
import script from "./templateContentSamplesModal.vue?vue&type=script&lang=ts&"
export * from "./templateContentSamplesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports